var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    mainBorderRadius: borders.radiusMedium,
    mainBackgroundColor: colors.contrasts.white1010,
    mainCorrectBorder: borders.widthMedium,
    mainCorrectBorderColor: colors.contrasts.green4570,
    mainIncorrectBorder: borders.widthMedium,
    mainIncorrectBorderColor: colors.contrasts.red4570,
    mainUnknownBorder: borders.widthMedium,
    mainUnknownBorderColor: colors.contrasts.grey4570,
    userResponsePadding: spacing.xxSmall,
    correctAnswerFontWeight: typography.fontWeightBold,
    correctAnswerPadding: spacing.xxSmall,
    iconColor: colors.contrasts.white1010,
    iconCorrectBackgroundColor: colors.contrasts.green4570,
    iconIncorrectBackgroundColor: colors.contrasts.red4570,
    iconUnknownBackgroundColor: colors.contrasts.grey4570,
    correctAnswerHolderFontSize: typography.fontSizeSmall
  };
};
export default generateComponentTheme;